// extracted by mini-css-extract-plugin
export var completionBody = "_bp-2";
export var completionCard = "_bp-0";
export var completionFooter = "_bp-3";
export var completionTitle = "_bp-1";